var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 544","d":"M2.897 13.746v-9.09H.087v9.09zm0-12.313A1.382 1.382 0 001.457 0 1.387 1.387 0 000 1.433a1.379 1.379 0 001.423 1.434h.017a1.387 1.387 0 001.457-1.434zm4.585 12.313V8.569a2.108 2.108 0 01.1-.752 1.688 1.688 0 011.584-1.128 1.677 1.677 0 011.816 1.88v5.177h2.83V8.43c0-2.85-1.521-4.176-3.55-4.176a3.071 3.071 0 00-2.8 1.563l.02-1.216H4.657c.041.871 0 9.148 0 9.148z","fill":"currentColor","fillRule":"evenodd"}));
}

LinkedinInline.defaultProps = {"viewBox":"0 0 13.812 13.75"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
